var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('performance-common-dialog',{ref:"performanceCommonDialog",attrs:{"title":'轨迹回放'},on:{"close":_vm.dialogClose},scopedSlots:_vm._u([{key:"top",fn:function(){return undefined},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }